import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { getUuid } from '@front10/helpers/dist/uuid';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';

import Box from '../../elements/Box';
import Select from '../../elements/Select';
import Text from '../../elements/Text';

const formatOptions = (options, optionsLabelsMap, translate) =>
  options.map((option) => {
    return {
      name: translate(optionsLabelsMap[option], optionsLabelsMap[option]),
      value: option,
      key: option
    };
  });

const StopsFilter = React.forwardRef((props, receivedRef) => {
  const ownRef = React.useRef();
  const ref = receivedRef || ownRef;
  const id = getUuid();
  const {
    options,
    value,
    onChange,
    labelsMap,
    dataTestId,
    components: { label, select },
    showLabel
  } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return (
    <Box className={`fr-clearfix ${className}`} style={style}>
      {showLabel && (
        <Text
          paddingTop="2"
          paddingRight="2"
          floatLeft
          type="label"
          htmlFor={`cmp-stops-filter-${id}`}
          {...label}
        >
          {translate('cmp-stops-number-label', 'Stops')}
        </Text>
      )}
      <Select
        id={`cmp-stops-filter-${id}`}
        dataTestId={dataTestId}
        ariaLabel={translate('cmp-stops-filter-aria-label', 'Stops')}
        ariaDescribedBy={`cmp-stops-filter-description-${id}`}
        options={formatOptions(options, labelsMap, translate)}
        value={value}
        onChange={onChange}
        fullWidth
        {...select}
        ref={ref}
      />
      <p id={`cmp-stops-filter-description-${id}`} className="fr-sr-only" aria-hidden="true">
        {translate('cmp-stops-filter-aria-label-description', 'Select the number of stops')}
      </p>
    </Box>
  );
});

StopsFilter.propTypes = {
  options: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  components: PropTypes.shape({
    label: PropTypes.objectOf(PropTypes.any),
    select: PropTypes.objectOf(PropTypes.any)
  }),
  showLabel: PropTypes.bool,
  dataTestId: PropTypes.string,
  /**
   * Labels keys for the options
   */
  labelsMap: PropTypes.objectOf(PropTypes.any)
};

StopsFilter.defaultProps = {
  dataTestId: '',
  options: ['any', 1, 0],
  value: 'any',
  labelsMap: {
    any: 'stop_count_any',
    1: 'stop_count_one',
    0: 'stop_count_none'
  },
  onChange: () => {},
  components: {
    label: {},
    select: {}
  },
  showLabel: true
};

StopsFilter.componentName = 'StopsFilter';

export default StopsFilter;
